module.exports = __webpack_public_path__ + "img/14.84336907.jpg";